module.exports = __webpack_public_path__ + "static/shantanu-9d3e39a88de892be490d4925cbcc8f9d.jpg";